import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconClipboard, IconEntree, IconHome, IconSortie } from "./icons";

const ONGLETS = [
  { key: "home", label: "Accueil", to: "/", Icon: IconHome },
  { key: "entree", label: "Entrée", to: "/scan-entree", Icon: IconEntree },
  { key: "sortie", label: "Sortie", to: "/scan-sortie", Icon: IconSortie },
  { key: "inventaires", label: "Inventaires", to: "/inventaires", Icon: IconClipboard },
];

/** Onglet actif : toutes les routes /inventaire* retombent sur « Inventaires ». */
const ongletActif = (pathname) => {
  if (pathname.startsWith("/scan-entree")) return "entree";
  if (pathname.startsWith("/scan-sortie")) return "sortie";
  if (pathname.startsWith("/inventaire")) return "inventaires";
  return "home";
};

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const actif = ongletActif(pathname);

  return (
    <nav className="bottom-nav">
      {ONGLETS.map(({ key, label, to, Icon }) => (
        <button
          key={key}
          type="button"
          className={actif === key ? "active" : ""}
          onClick={() => navigate(to)}
        >
          <Icon size={21} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
